export type FacilityKey = 'walking-track';

interface Facility {
  name: string;
  // When true, the sponsoring business is named as part of the facility's public name.
  namingRights: boolean;
}

export const facilities: Record<FacilityKey, Facility> = {
  'walking-track': { name: 'Walking Track', namingRights: true }
};

export interface Sponsor {
  id: number;
  name: string;
  tier: 'diamond';
  logo?: string;
  logoClass?: string;
  website?: string;
  sponsoredFacilities?: FacilityKey[];
}

export const sponsors: Sponsor[] = [
  {
    id: 1,
    name: 'Polk County Fair',
    tier: 'diamond',
    logo: '/PCFairLogo.png',
    website: 'https://www.polkcountyfairfertilemn.com/'
  },
  {
    id: 2,
    name: 'Fertile Oil Company',
    tier: 'diamond',
    logo: '/FOCLogo.png',
    website: 'https://www.fertileoil.com/'
  },
  {
    id: 3,
    name: 'Scheels',
    tier: 'diamond',
    logo: '/SCHEELS_Logo.png',
    website: 'https://www.scheels.com/'
  },
  {
    id: 4,
    name: 'Fertile-Beltrami Booster Club',
    tier: 'diamond',
    logo: '/FBBoosterLogo.png',
    website: 'https://www.fertilebeltrami.k12.mn.us/websites/Booster%20Club/index.html'
  },
  {
    id: 5,
    name: 'Maynards Plumbing and Heating',
    tier: 'diamond',
    logo: '/maynardsplumbinglogo.png',
    website: 'https://www.facebook.com/maynardsplumbingheating'
  },
  {
    id: 6,
    name: 'Lakeside Digital',
    tier: 'diamond',
    logo: '/lakesidedigitalcircularlogo.png',
    website: 'https://lakesidedigitalmn.com'
  },
  {
    id: 7,
    name: 'Essentia Health',
    tier: 'diamond',
    logo: '/essentiahealthlogo.png',
    website: 'https://www.essentiahealth.org/',
    sponsoredFacilities: ['walking-track']
  }
];

export const getFacilitySponsors = (facility: FacilityKey): Sponsor[] =>
  sponsors.filter((sponsor) => sponsor.sponsoredFacilities?.includes(facility));

export const getFacilityName = (facility: FacilityKey): string => facilities[facility].name;

export const getFacilityDisplayName = (facility: FacilityKey): string => {
  const { name, namingRights } = facilities[facility];
  const [namingSponsor] = getFacilitySponsors(facility);

  return namingRights && namingSponsor ? `${namingSponsor.name} ${name}` : name;
};
